import { createFileRoute } from '@tanstack/react-router'
import { ObjectView } from 'pages/objectViews/ObjectView'
import { z } from 'zod'

const objectViewSearchSchema = z.object({})

// Legacy route structure includes org ID for compatibility with sidebar org name
// and to ensure clear ontology context when navigating between objects
// Ideally we'd drop the org ID from the path.
export const Route = createFileRoute('/prism/$orgID/$entryId')({
  component: ObjectView,
  staticData: {
    title: 'Object View',
  },
  validateSearch: objectViewSearchSchema,
})
